module.exports = __webpack_public_path__ + "img/9.8b4aff11.svg";